import React from 'react';

type Props = {
  tabs?: React.ReactNode;
  children?: React.ReactNode;
  size?: 'large' | 'extra-large';
};

export function FullWidthTabsPageLayout({ children, tabs, size }: Props) {
  const maxWidth = size === 'extra-large' ? '1600px' : size === 'large' ? '1400px' : undefined;

  return (
    <div className={`layout-v3 d-flex flex-column h-100`}>
      {tabs && (
        <div className="border-bottom bg-white tabs-border">
          <div className={`${maxWidth ? 'mx-auto' : ''}`} style={{ ...(maxWidth ? { width: maxWidth, maxWidth: '100%' } : {}) }}>
            {tabs}
          </div>
        </div>
      )}
      <div
        className={`${maxWidth ? 'mx-auto' : 'w-100'} d-flex flex-column flex-grow-1 min-height-0`}
        style={{ ...(maxWidth ? { width: maxWidth, maxWidth: '100%' } : {}), maxHeight: '100%' }}
      >
        {children}
      </div>
    </div>
  );
}
